import { isArray, isEmpty } from 'es-toolkit/compat';

const isEmptyOrNestedEmptyArray = (value: unknown) =>
  isArray(value) && (isEmpty(value) || (value.length === 1 && isArray(value[0]) && isEmpty(value[0])));

export const getDataIsEmpty = (data: any, isLinked?: boolean) => {
  if (isLinked) {
    return false;
  }
  if (!data || isEmptyOrNestedEmptyArray(data?.rows)) {
    return true;
  }
  if (isArray(data) && (isEmpty(data) || (data.length > 1 && isEmpty(Object.values(data[1]))))) {
    return true;
  }
  if (isEmpty(Object.values(data))) {
    return true;
  }
  return false;
};
